import { useEffect, useState } from "react";
import {
  TextField,
  IconButton,
  Dialog,
  Box,
  Tooltip,
  Container,
  Stack,
  Button,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";

import conf from "config-dlm";
import InfoChip from "components/utils/InfoChip";
import SectionHeader from "components/utils/SectionHeader";
import { useUserServiceUpdateTags } from "hooks/user/projects";

type TagsWithEditProps = {
  id: string;
  tags: string[];
  isAdmin: boolean;
};
const TagsWithEdit = (props: TagsWithEditProps) => {
  const { id, isAdmin } = props;

  const update = useUserServiceUpdateTags();

  const [tags, setTags] = useState<string[]>(props.tags);
  const [current, setCurrent] = useState<string>("");
  const [isEditing, setIsEditing] = useState(false);

  const add = () => {
    if (!!current.trim() && !tags.includes(current)) {
      const updated = [...tags, current.trim()];
      update.mutate({ id, tags: updated });

      setTags(updated);
      setCurrent("");
    }
  };

  const remove = (tag: string) => {
    const updated = tags.filter((cur) => cur !== tag);

    setTags(updated);
    update.mutate({ id, tags: updated });
  };

  const handleOpen = () => setIsEditing(true);
  const handleClose = () => {
    setCurrent("");
    setIsEditing(false);
  };

  const TagChip = (
    <InfoChip
      size="small"
      color="primary"
      info={tags.join(", ")}
      icon={<EditIcon sx={{ fontSize: 18 }} />}
    />
  );

  return (
    <>
      {/* Tags and Edit Button */}
      <Box display="flex" alignItems="end" justifyContent="flex-end">
        {isAdmin ? (
          <IconButton onClick={handleOpen} color="inherit">
            {TagChip}
          </IconButton>
        ) : (
          TagChip
        )}
      </Box>

      {/* Edit Modal */}
      <Dialog fullWidth maxWidth="md" open={isEditing} onClose={handleClose}>
        <Container component="main" sx={conf.STYLE.DIALOG}>
          <SectionHeader
            title="Edit tags"
            icon={<EditIcon />}
            buttons={[
              <Button
                key="tags-edit-close"
                variant="outlined"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon />
              </Button>,
            ]}
          />

          <Stack direction="row" spacing={1} m={2} flexWrap="wrap">
            {tags.map((tag) => (
              <Chip
                color="primary"
                variant="filled"
                key={tag}
                label={tag}
                onDelete={() => remove(tag)}
                deleteIcon={
                  <Tooltip title="delete">
                    <RemoveIcon />
                  </Tooltip>
                }
              />
            ))}
          </Stack>

          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ mt: 2 }}
          >
            <TextField
              size="small"
              label="Add tag"
              variant="outlined"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && add()}
            />

            {/* <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button> */}

            <Button variant="contained" onClick={add} disabled={!current}>
              Add
            </Button>
          </Stack>
        </Container>
      </Dialog>
    </>
  );
};

export default TagsWithEdit;
